<template>
  <div class="tags-view-container" v-if="tagsView.visitedViews.length">
    <div class="tags-view-wrapper" ref="scrollPane">
      <router-link
        v-for="tag in tagsView.visitedViews"
        ref="tag"
        :key="tag.path"
        :class="['tags-view-item', { active: isActive(tag) }]"
        :to="{ path: tag.path, query: tag.query }"
        @contextmenu.prevent.native="openMenu(tag, $event)"
      >
        <span class="tags-view-item-title">{{ tag.title }}</span>
        <span
          v-if="!tagsView.isFixedHome(tag.path)"
          class="el-icon-close tags-view-item-close"
          @click.prevent.stop="closeTag(tag)"
        ></span>
      </router-link>
    </div>

    <ul
      v-show="visible"
      :style="{ left: menuLeft + 'px', top: menuTop + 'px' }"
      class="context-menu"
    >
      <li @click="closeSelectedTag(selectedTag)">关闭当前</li>
      <li @click="closeOthersTags">关闭其他</li>
      <li @click="closeAllTags">关闭全部</li>
    </ul>
  </div>
</template>

<script>
import tagsView from '@/utils/tagsView'

export default {
  name: 'TagsView',
  data() {
    return {
      tagsView,
      visible: false,
      menuTop: 0,
      menuLeft: 0,
      selectedTag: {}
    }
  },
  computed: {
    currentRoute() {
      return this.$route
    }
  },
  watch: {
    visible(value) {
      if (value) {
        document.addEventListener('click', this.closeMenu)
      } else {
        document.removeEventListener('click', this.closeMenu)
      }
    },
    $route: {
      handler() {
        this.addTags()
        this.moveToCurrentTag()
      },
      immediate: false
    }
  },
  mounted() {
    this.addTags()
  },
  methods: {
    isActive(tag) {
      return tag.path === this.$route.path
    },

    addTags() {
      const route = this.$route
      if (route.name) {
        tagsView.addView(route)
      }
    },

    moveToCurrentTag() {
      const tags = this.$refs.tag
      if (!tags) return
      this.$nextTick(() => {
        const container = this.$refs.scrollPane
        if (!container) return
        const currentTag = Array.from(tags).find(tag => {
          return tag.to && tag.to.path === this.$route.path
        })
        if (currentTag) {
          currentTag.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
        }
      })
    },

    closeTag(view) {
      tagsView.removeView(view)
      if (this.isActive(view)) {
        this.toLastView()
      }
    },

    toLastView() {
      const lastView = tagsView.toLastView(this.$route)
      if (lastView) {
        this.$router.push(lastView.fullPath)
      } else {
        this.$router.push(tagsView.fixedHomePath)
      }
    },

    openMenu(tag, e) {
      this.menuLeft = e.clientX
      this.menuTop = e.clientY
      this.visible = true
      this.selectedTag = tag
    },

    closeMenu() {
      this.visible = false
    },

    closeSelectedTag(view) {
      tagsView.removeView(view)
      this.closeMenu()
      if (this.isActive(view)) {
        this.toLastView()
      }
    },

    closeOthersTags() {
      tagsView.closeOthers(this.selectedTag)
      this.closeMenu()
      if (!this.isActive(this.selectedTag)) {
        this.$router.push(this.selectedTag.fullPath)
      }
    },

    closeAllTags() {
      tagsView.closeAll()
      this.closeMenu()
      this.$router.push(tagsView.fixedHomePath)
    }
  }
}
</script>

<style scoped>
.tags-view-container {
  width: 100%;
  position: relative;
  margin-bottom: 0;
}

.tags-view-wrapper {
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding: 6px 8px;
  background: #fff;
  border-radius: var(--radius-md, 8px);
  border: 1px solid var(--color-border, #e4e7ed);
  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.06));
}

.tags-view-wrapper::-webkit-scrollbar {
  height: 3px;
}
.tags-view-wrapper::-webkit-scrollbar-thumb {
  background: #d0d5dd;
  border-radius: 3px;
}

.tags-view-item {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 12px;
  margin: 0 4px 0 0;
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-secondary, #606266);
  background-color: #f5f7fa;
  border: 1px solid transparent;
  border-radius: var(--radius-sm, 4px);
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s, background 0.2s, border-color 0.2s;
  flex-shrink: 0;
}

.tags-view-item:hover {
  color: var(--color-primary, #409EFF);
  background-color: var(--color-primary-soft, #ecf5ff);
}

.tags-view-item.active {
  color: var(--color-primary, #409EFF);
  background: var(--color-primary-soft, #ecf5ff);
  border-color: rgba(64, 158, 255, 0.35);
  font-weight: 600;
}

.tags-view-item-title {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tags-view-item-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-left: 4px;
  font-size: 10px;
  transition: background 0.15s, color 0.15s;
}

.tags-view-item-close:hover {
  background-color: rgba(0, 0, 0, 0.08);
  color: var(--color-text, #303133);
}

.tags-view-item.active .tags-view-item-close:hover {
  background-color: rgba(64, 158, 255, 0.2);
  color: var(--color-primary, #409EFF);
}

.context-menu {
  position: fixed;
  z-index: 10001;
  margin: 0;
  padding: 4px 0;
  background: #fff;
  border-radius: var(--radius-md, 8px);
  box-shadow: var(--shadow-md, 0 4px 16px rgba(15, 23, 42, 0.08));
  list-style: none;
  min-width: 120px;
  border: 1px solid var(--color-border, #e4e7ed);
  overflow: hidden;
}

.context-menu li {
  padding: 8px 16px;
  font-size: 13px;
  color: var(--color-text, #303133);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.context-menu li:hover {
  color: var(--color-primary, #409EFF);
  background-color: var(--color-primary-soft, #ecf5ff);
}
</style>
